<template>
  <StyledActionBar class="payment-methods__select-payment-wrap">
    <styled-select
      v-on-clickaway="closeMethodSelector"
      :method-selector-is-open="methodSelectorIsOpen"
      @click="toggleMethodSelector"
    >
      <span ref="selectPaymentText">{{ $t(activeTab) }}</span>
      <arrow-down-svg />

      <transition name="transition-select-payment">
        <styled-select-options-wrapper v-if="methodSelectorIsOpen">
          <li v-for="tab in tabs" :key="tab" @click="handleTabSelect(tab)">
            {{ $t(tab) }}
          </li>
        </styled-select-options-wrapper>
      </transition>
    </styled-select>
    <div v-if="showGeo && false" class="mob-globe">
      <mob-globe-svg />
    </div>

    <div v-if="showSearchLogo" class="mob-search" style="padding: 10px;" @click="clickSearch">
      <div class="mob-search__loop">
        <mob-search-svg />
      </div>
    </div>
  </StyledActionBar>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';
import { mapActions, mapState } from 'vuex';

import styled from 'vue-styled-components';

const selectProps = {
  methodSelectorIsOpen: Boolean,
};
const StyledActionBar = styled('div', {})`
  background: transparent !important;
  .mob-search__loop {
    &:hover {
      svg path {
        fill: ${props => props.theme.primary};
      }
    }
  }
`;
const styledSelect = styled('div', selectProps)`
  line-height: 1;
  transition: ${props => props.theme.default_transition};
  &:hover {
    background-color: ${props => props.theme.primary};
    color: ${props => props.theme.on_primary};

    cursor: pointer;
  }

  svg {
    transform: ${props => (props.methodSelectorIsOpen ? 'rotate(180deg)' : 'none')};
    transition: ${props => props.theme.default_transition};
    stroke: ${props =>
      props.methodSelectorIsOpen ? props.theme.on_primary : props.theme.on_surface};
  }

  background-color: ${props =>
    props.methodSelectorIsOpen ? props.theme.primary : props.theme.surface};

  color: ${props =>
    props.methodSelectorIsOpen ? props.theme.on_primary : props.theme.on_background};

  border: ${props => props.theme.border};
  border-color: ${props => props.theme.border_color};
  border-radius: ${props => props.theme.border_radius};

  padding: 0 15px 0 10px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const styledSelectOptionsWrapper = styled('ul', selectProps)`
  background-color: ${props => props.theme.surface};
  border-color: ${props => props.theme.on_surface};
  color: ${props => props.theme.on_surface};

  border: ${props => props.theme.border};
  border-radius: ${props => props.theme.border_radius};
  box-shadow: ${props => props.theme.box_shadow};

  text-align: left;
  display: block;
  position: absolute;
  left: 20px;
  top: 50px;
  width: calc(100% - 40px);
  z-index: 100;
  overflow: hidden;
  li {
    &:focus,
    &:active,
    &:hover {
      background-color: ${props => props.theme.primary};
      color: ${props => props.theme.on_primary_color};
      transition: ${props => props.theme.default_transition};
    }
    padding: 10px 20px;
    background-color: ${props => props.theme.surface};
    color: ${props => props.theme.on_surface};
  }
`;

import ArrowDownSvg from '@/components/svg/ArrowDown';
import MobGlobeSvg from '@/components/svg/MobGlobe';
import MobSearchSvg from "@/components/svg/MobSearch";


export default {
  components: {
    ArrowDownSvg,
    MobGlobeSvg,
    MobSearchSvg,
    styledSelect,
    styledSelectOptionsWrapper,
    StyledActionBar,
  },
  filters: {
    capitalize(str) {
      return str[0].toUpperCase() + str.slice(1);
    },
  },
  data() {
    return {
      methodSelectorIsOpen: false,
      activeTab: null,
      showSearchLogo: true,
    };
  },
  watch: {
    tabs(nVal) {
      this.handleTabSelect(nVal[0]);
    },
  },
  created() {
    if (this.tabs && !this.activeTab) {
      this.handleTabSelect(this.tabs[0]);
    }
  },

  computed: {
    ...mapState(['categories']),

    tabs() {
      return this.categories;
    },

    showGeo() {
      return false;
    },
  },

  methods: {
    ...mapActions(['selectCategory']),

    toggleMethodSelector() {
      this.methodSelectorIsOpen = !this.methodSelectorIsOpen;
    },

    closeMethodSelector() {
      this.methodSelectorIsOpen = false;
    },

    clickSearch() {
      this.$bus.$emit('searchClick', true);
    },

    getRoute(code) {
      if (code === 'test') {
        return { name: 'test', query: { 'payment-request': this.requestId } };
      }

      return {
        name: 'pm',
        params: { pm: code },
        query: { 'payment-request': this.requestId },
      };
    },

    handleTabSelect(name) {
      this.activeTab = name;
      this.tabs.forEach(el => {
        if (el === name) {
          if (this.$route.name === 'test' || this.$route.name === 'pm') {
            // this.$router.push({
            //   name: "PaymentMethodsListPage",
            //   query: { "payment-request": this.requestId }
            // });
          }
          this.selectCategory(name);
        }
      });
    },
  },

  directives: { onClickaway },
};
</script>
